
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FolderItemProps } from ".";
import { loading, update } from "store/folder";

interface ApiFolderUpdateInputProps extends FolderItemProps {
    parentId?: number;
}

type ApiFolderUpdateOutputProps = OutputBaseProps<{ item: FolderItemProps; }, ApiFolderUpdateInputProps>

export const apiFolderUpdate = async (data: ApiFolderUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiFolderUpdateOutputProps>("/api/folder/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};